export default __webpack_public_path__ + "static/media/5-Card.8fdb99ba.jpg";